<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>Exhibiting</BreadcrumbItem>
          <BreadcrumbItem>Parking Permit</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="addShow = true">
          <span class="htb-add">+</span>
          <span>Add parking permit</span>
        </div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="Confirmed" name="1">
          <exhibitionCarYes
            :addShow="addShow"
            @closeModal=" addShow = false; showTabs='2'"
            v-if="String(showTabs) === '1'"
          ></exhibitionCarYes>
        </TabPane>
        <TabPane label="Not reviewed" name="2">
          <exhibitionCarNo
            :addShow="addShow"
            @closeModal=" addShow = false"
            v-if="String(showTabs) === '2'"
          ></exhibitionCarNo>
        </TabPane>
      </Tabs>
    </div>

    <div class="catalogue-content"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import exhibitionCarYes from "./components/exhibition-car-yes";
import exhibitionCarNo from "./components/exhibition-car-no";

export default {
  name: "exhibition-info-carApply",
  data() {
    return {
      addShow: false,
      showTabs: "1"
    };
  },
  components: {
    exhibitionCarYes,
    exhibitionCarNo
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition"
    })
  },
  created() {
    document.title = "国际焙烤展 - Parking Permit";
  },
  methods: {
    switchBrand(name) {
      // if (name === "1") {
      //   this.$router.push(`${this.$route.path}?type=all`);
      // } else if (name === "2") {
      //   this.$router.push(`${this.$route.path}?type=mes`);
      // } else if (name === "3") {
      //   this.$router.push(`${this.$route.path}?type=apply`);
      // }
    }
  }
};
</script>

<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}
</style>
